var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNivelCond(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 22,
    viewBox: "0 0 16 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10 21.5V15.5L7.9 13.5L6.9 17.9L0 16.5L0.4 14.5L5.2 15.5L6.8 7.4L5 8.1V11.5H3V6.8L6.95 5.1C7.53333 4.85 7.9625 4.6875 8.2375 4.6125C8.5125 4.5375 8.76667 4.5 9 4.5C9.35 4.5 9.675 4.59167 9.975 4.775C10.275 4.95833 10.5167 5.2 10.7 5.5L11.7 7.1C12.1333 7.8 12.7208 8.375 13.4625 8.825C14.2042 9.275 15.05 9.5 16 9.5V11.5C14.9 11.5 13.8708 11.2708 12.9125 10.8125C11.9542 10.3542 11.15 9.75 10.5 9L9.9 12L12 14V21.5H10ZM10.5 4C9.95 4 9.47917 3.80417 9.0875 3.4125C8.69583 3.02083 8.5 2.55 8.5 2C8.5 1.45 8.69583 0.979167 9.0875 0.5875C9.47917 0.195833 9.95 0 10.5 0C11.05 0 11.5208 0.195833 11.9125 0.5875C12.3042 0.979167 12.5 1.45 12.5 2C12.5 2.55 12.3042 3.02083 11.9125 3.4125C11.5208 3.80417 11.05 4 10.5 4Z",
    fill: "#000E4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNivelCond);
export default __webpack_public_path__ + "static/media/nivel_cond.fff99c8b36a32269630571a3ea498374.svg";
export { ForwardRef as ReactComponent };